import { useAtom, useAtomValue } from "jotai";
import { currentUserAtom, isUserLoadingAtom, setUserAtom, userBrandsAtom, userErrorAtom } from "@/store/user";
import { User, UserBrand } from "@/core/entities/user";

interface UseUser {
  user: User | null;
  isLoading: boolean;
  userBrands: UserBrand[] | null;
  error: Error | null;
  setUser: () => Promise<void>;
}

export const useUser = (): UseUser => {
  // Read-only atoms
  const user = useAtomValue(currentUserAtom);
  const isLoading = useAtomValue(isUserLoadingAtom);
  const userBrands = useAtomValue(userBrandsAtom);
  const error = useAtomValue(userErrorAtom);

  // Action atoms
  const [, setUser] = useAtom(setUserAtom);

  return {
    // State
    user,
    isLoading,
    userBrands,
    error,

    // Actions
    setUser,
  };
};
